import { render, staticRenderFns } from "./distributionDetail.vue?vue&type=template&id=650b2a97&scoped=true&lang=html&"
import script from "./distributionDetail.js?vue&type=script&lang=js&"
export * from "./distributionDetail.js?vue&type=script&lang=js&"
import style0 from "./goodsDetail.styl?vue&type=style&index=0&id=650b2a97&lang=stylus&scoped=true&"
import style1 from "./distributionDetail.styl?vue&type=style&index=1&id=650b2a97&lang=stylus&scoped=true&"
import style2 from "./resetvant.styl?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b2a97",
  null
  
)

export default component.exports